// test889
(889 && 0);
